import _ from 'lodash';

/**
 * Use in the default of a switch to assert that all possible cases of a
 * tagged-union-style type have been covered.
 * From http://www.typescriptlang.org/docs/handbook/advanced-types.html
 */
/* istanbul ignore next */
export function assertNever(x: never): never {
  throw new Error('Unexpected object: ' + x);
}

/**
 * Helper function to go with lodash _.filter so that it will type check
 * correctly that the result no longer includes nil values
 * @param item The item that might be null or undefined
 */
export function filterNilValues<T>(item: T | null | undefined): item is T {
  return !_.isNil(item);
}

/**
 * Helper function for asserting that an array is not empty
 */
export function isNotEmpty<T>(arr: T[]): arr is NonEmptyArray<T> {
  return !_.isEmpty(arr);
}

export function headOfNonEmpty<T>(arr: NonEmptyArray<T>): T {
  return arr[0];
}

export function lastOfNonEmpty<T>(arr: NonEmptyArray<T>): T {
  return arr[arr.length - 1];
}

export function isPresent<T>(x: T | null | undefined): x is T {
  return !!x;
}

/**
 * Obtains a collection of ids from a collection of objects with ids
 * @param collection A colletion of objects with an id field
 * @returns The nil-filtered collection of ids from the source collection
 */
export function getCollectionIds(
  collection: {
    id?: number | null | undefined;
  }[]
): number[] {
  return _.filter(
    collection.map((item) => item.id),
    filterNilValues
  );
}
